import logo from "./logo.svg";
import "./App.css";
import HomePage from "./pages/HomePage/HomePage";
import AdminHomePage from "./pages/AdminHomePage/AdminHomePage";
import AppLayout from "./layouts/appLayout/AppLayout";
import NotFoundPage from "./pages/NotFoundPage";
import AdminLayout from "./layouts/adminLayout/AdminLayout";
import { Navigate, Route, Routes } from "react-router-dom";
import LoginPage from "./pages/Loginage/LoginPage";
import SignupPage from "./pages/SignupPage/SignupPage";
import { useAuth } from "./context/AuthContext";
import AdminStudyPage from "./pages/AdminStudyPage/AdminStudyPage";
import AdminUserPage from "./pages/AdminUserPage/AdminUserPage";

import AdminDashboard from "./pages/AdminDashboard/AdminDashboard";
import AdminStudentPage from "./pages/AdminStudentPage/AdminStudentPage";
import AdminAgendaPage from "./pages/AdminAgendaPage/AdminAgendaPage";
import AssignmentPage from "./pages/AssignmentPage/AssignmentPage";
import AdminAssignmentPage from "./pages/AdminAssignmentPage/AdminAssignmentPage";
import AdminTAPage from "./pages/AdminTAPage/AdminTAPage";

const ProtectedRoute = ({ children }) => {
  const { currentUser } = useAuth();

  if (!currentUser) {
    // 유저가 로그인하지 않았다면 로그인 페이지로 리다이렉트
    return <Navigate to="/login" />;
  }

  return children;
};
function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />

      <Route
        path="/"
        element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<HomePage />} />
        <Route path="study/:studyId" element={<AssignmentPage />} />

        {/* AppLayout 내의 다른 사용자 페이지 라우트를 여기에 추가 */}
      </Route>
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<AdminDashboard />} />
        <Route path="study" element={<AdminStudyPage />} />
        <Route path="user" element={<AdminUserPage />} />
        <Route path="student" element={<AdminStudentPage />} />
        <Route path="agenda" element={<AdminAgendaPage />} />
        <Route path="assignment" element={<AdminAssignmentPage />} />
        <Route path="ta" element={<AdminTAPage />} />
        {/* AdminLayout 내의 다른 관리자 페이지 라우트를 여기에 추가 */}
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default App;
